import React from 'react';
import { useNavigate } from 'react-router-dom';
import MovdButton from '../design-system/MovdButton.jsx';

const steps = [
  { number: '01', title: 'Build your move', description: 'Add your route, preferred date, move size, and access details so MOVD understands what you need.' },
  { number: '02', title: 'Review your options', description: 'See movers that can serve the move you built, then compare the details provided with each quote.' },
  { number: '03', title: 'Book with clarity', description: 'Choose an option, confirm your move details, and complete your booking securely in one connected flow.' },
];

const eyebrowStyle = { margin: '0 0 12px', color: '#008d7b', fontWeight: 900, letterSpacing: '.1em', fontSize: '.75rem' };
const heroTitleStyle = { margin: '0 0 18px', maxWidth: 700, color: '#102449', fontWeight: 900, fontSize: 'clamp(2.5rem, 5vw, 4.25rem)', lineHeight: .98, letterSpacing: 0 };
const heroCopyStyle = { margin: 0, maxWidth: 560, color: '#405875', fontSize: '1.08rem', lineHeight: 1.6 };
const sectionTitleStyle = { margin: 0, fontSize: '2.25rem', fontWeight: 900, letterSpacing: 0 };

export default function HowItWorksPage() {
  const navigate = useNavigate();
  return <main style={{ minHeight: '100vh', background: '#f8fafb', color: '#102449' }}>
    <section style={{ background: '#e5f7f4', borderBottom: '1px solid #d0e9e4', padding: 'clamp(52px, 8vw, 88px) 20px' }}>
      <div style={{ maxWidth: 1120, margin: '0 auto' }}>
        <p style={eyebrowStyle}>THE MOVD PROCESS</p>
        <h1 style={heroTitleStyle}>A clearer way<br />to plan a move.</h1>
        <p style={heroCopyStyle}>Build your move once, then use the same details to compare options and book when you are ready.</p>
      </div>
    </section>
    <section style={{ maxWidth: 1120, margin: '0 auto', padding: 'clamp(48px, 7vw, 76px) 20px' }}>
      <p style={eyebrowStyle}>THREE SIMPLE STEPS</p>
      <h2 style={sectionTitleStyle}>From first detail to booking</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 18, marginTop: 32 }}>
        {steps.map(step => <article key={step.number} style={{ padding: 28, minHeight: 210, background: '#fff', border: '1px solid #dce9e7', borderRadius: 8 }}>
          <p style={{ margin: '0 0 42px', color: '#008d7b', fontWeight: 900, fontSize: '.82rem' }}>{step.number}</p>
          <h3 style={{ margin: '0 0 10px', fontSize: '1.2rem', fontWeight: 900 }}>{step.title}</h3>
          <p style={{ margin: 0, color: '#52637c', lineHeight: 1.6, fontSize: '.94rem' }}>{step.description}</p>
        </article>)}
      </div>
      <div style={{ marginTop: 48, padding: 'clamp(28px, 5vw, 48px)', background: '#102449', color: '#fff', borderRadius: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
        <div><p style={{ margin: '0 0 8px', color: '#8de2d7', fontSize: '.75rem', fontWeight: 900, letterSpacing: '.1em' }}>READY WHEN YOU ARE</p><h2 style={{ margin: 0, fontSize: '1.8rem', fontWeight: 900 }}>Start building your move.</h2></div>
        <MovdButton onClick={() => navigate('/')}>Start your move</MovdButton>
      </div>
    </section>
  </main>;
}
